export const LOAD_OFFER_FEES_SUCCESS = "LOAD_OFFER_FEES_SUCCESS";
export const OFFER_FEES_CATALOG_UPDATED = "OFFER_FEES_CATALOG_UPDATED";
export const LOAD_OFFER_FEES_STARTED = "LOAD_OFFER_FEES_STARTED";
export const LOAD_OFFER_FEES_FAILED = "LOAD_OFFER_FEES_FAILED";
export const UPDATE_OFFER_FEES_STARTED = "UPDATE_OFFER_FEES_STARTED";
export const UPDATE_OFFER_FEES_CATALOG_FAILED = "UPDATE_OFFER_FEES_CATALOG_FAILED";
export const LOAD_OFFER_FEES_NEGOTIATION_DATA_STARTED = "LOAD_OFFER_FEES_NEGOTIATION_DATA_STARTED";
export const LOAD_OFFER_FEES_NEGOTIATION_DATA_SUCCEEDED = "LOAD_OFFER_FEES_NEGOTIATION_DATA_SUCCEEDED";
export const LOAD_OFFER_FEES_NEGOTIATION_DATA_FAILED = "LOAD_OFFER_FEES_NEGOTIATION_DATA_FAILED";
export const CHANGE_EDITABLE_PROPERTY = "CHANGE_EDITABLE_PROPERTY";
export const CANCEL_OFFER_FEES_CHANGES = "CANCEL_OFFER_FEES_CHANGES";
export const LOAD_SCHEMA_EXCHANGE_RATE_STARTED = "LOAD_SCHEMA_EXCHANGE_RATE_STARTED";
export const LOAD_SCHEMA_EXCHANGE_RATE_FAILED = "LOAD_SCHEMA_EXCHANGE_RATE_FAILED";
export const LOAD_SCHEMA_EXCHANGE_RATE_SUCCESS = "LOAD_SCHEMA_EXCHANGE_RATE_SUCCESS";

export const UPDATE_OFFER_FEES_START_NEGOTIATION_STARTED = "UPDATE_OFFER_FEES_START_NEGOTIATION_STARTED";
export const UPDATE_OFFER_FEE_START_NEGOTIATION_SUCCEEDED = "UPDATE_OFFER_FEE_START_NEGOTIATION_SUCCEEDED";
export const UPDATE_OFFER_FEE_START_NEGOTIATION_FAILED = "UPDATE_OFFER_FEE_START_NEGOTIATION_FAILED";
export const UPDATE_OFFER_FEES_SEND_IN_APPROVAL_STARTED = "UPDATE_OFFER_FEES_SEND_IN_APPROVAL_STARTED";
export const UPDATE_OFFER_FEE_SEND_IN_APPROVAL_SUCCEEDED = "UPDATE_OFFER_FEE_SEND_IN_APPROVAL_SUCCEEDED";
export const UPDATE_OFFER_FEE_SEND_IN_APPROVAL_FAILED = "UPDATE_OFFER_FEE_SEND_IN_APPROVAL_FAILED";
export const UPDATE_OFFER_FEES_CONFIRM_NEGOTIATION_STARTED = "UPDATE_OFFER_FEES_CONFIRM_NEGOTIATION_STARTED";
export const UPDATE_OFFER_FEE_CONFIRM_NEGOTIATION_SUCCEEDED = "UPDATE_OFFER_FEE_CONFIRM_NEGOTIATION_SUCCEEDED";
export const UPDATE_OFFER_FEE_CONFIRM_NEGOTIATION_FAILED = "UPDATE_OFFER_FEE_CONFIRM_NEGOTIATION_FAILED";
export const UPDATE_OFFER_FEES_CONFIRM_PARTNER_NEGOTIATION_STARTED =
  "UPDATE_OFFER_FEES_CONFIRM_PARTNER_NEGOTIATION_STARTED";
export const UPDATE_OFFER_FEE_CONFIRM_PARTNER_NEGOTIATION_SUCCEEDED =
  "UPDATE_OFFER_FEE_CONFIRM_PARTNER_NEGOTIATION_SUCCEEDED";
export const UPDATE_OFFER_FEE_CONFIRM_PARTNER_NEGOTIATION_FAILED =
  "UPDATE_OFFER_FEE_CONFIRM_PARTNER_NEGOTIATION_FAILED";
export const UPDATE_OFFER_FEES_CONFIRM_PARTNER_GROUP_NEGOTIATION_STARTED =
  "UPDATE_OFFER_FEES_CONFIRM_PARTNER_GROUP_NEGOTIATION_STARTED";
export const UPDATE_OFFER_FEE_CONFIRM_PARTNER_GROUP_NEGOTIATION_SUCCEEDED =
  "UPDATE_OFFER_FEE_CONFIRM_PARTNER_GROUP_NEGOTIATION_SUCCEEDED";
export const UPDATE_OFFER_FEE_CONFIRM_PARTNER_GROUP_NEGOTIATION_FAILED =
  "UPDATE_OFFER_FEE_CONFIRM_PARTNER_GROUP_NEGOTIATION_FAILED";
export const UPDATE_OFFER_FEE_APPROVAL1_STARTED = "UPDATE_OFFER_FEE_APPROVAL1_STARTED";
export const UPDATE_OFFER_FEE_APPROVAL1_SUCCEDED = "UPDATE_OFFER_FEE_APPROVAL1_SUCCEDED";
export const UPDATE_OFFER_FEE_APPROVAL1_FAILED = "UPDATE_OFFER_FEE_APPROVAL1_FAILED";
export const UPDATE_OFFER_FEE_APPROVAL2_STARTED = "UPDATE_OFFER_FEE_APPROVAL2_STARTED";
export const UPDATE_OFFER_FEE_APPROVAL2_SUCCEDED = "UPDATE_OFFER_FEE_APPROVAL2_SUCCEDED";
export const UPDATE_OFFER_FEE_APPROVAL2_FAILED = "UPDATE_OFFER_FEE_APPROVAL2_FAILED";
